import { usePartner } from 'components/app/routes/usePartner';
import { PARTNERS } from 'config/app-config';
import { useFlags } from 'launchdarkly-react-client-sdk';

type RevampJourneyHook = {
  isRevampJourney: boolean;
};

export const useRevampJourney = (): RevampJourneyHook => {
  const { releaseQuotingEvForHomeMoveJourney } = useFlags();
  const { isDSJourney, activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];

  return {
    isRevampJourney:
      isDSJourney || (isMoveInJourney && releaseQuotingEvForHomeMoveJourney)
  };
};
